import { LinearProgress, styled, Theme } from '@mui/material'
import { JobStatusType } from 'features/jobs/types'
import { isPendingOrRunning } from 'features/jobs/models/jobs'

const getProgressBarColor = (jobStatus: JobStatusType, theme: Theme) => {
  switch (jobStatus) {
    case JobStatusType.Success:
      return theme.palette.success.main
    case JobStatusType.Failure:
      return theme.palette.error.main
    case JobStatusType.Cancelled:
      return theme.palette.action.disabledBackground
    default:
      return theme.palette.primary.main
  }
}

const JobStatusProgressBar = styled(LinearProgress, { shouldForwardProp: (prop) => prop !== 'jobStatus' })<{
  jobStatus: JobStatusType
}>(({ theme, jobStatus }) => ({
  '& .MuiLinearProgress-bar': {
    background: getProgressBarColor(jobStatus, theme)
  },
  height: '2px'
}))

function JobItemProgress({ jobStatus }: { jobStatus: JobStatusType }) {
  const variant = isPendingOrRunning(jobStatus) ? 'indeterminate' : 'determinate'
  const value = isPendingOrRunning(jobStatus) ? undefined : 100
  return <JobStatusProgressBar jobStatus={jobStatus} variant={variant} data-status={jobStatus} value={value} />
}

export default JobItemProgress
